import { gql } from "@apollo/client";

export const GET_PACIENTE_SAP_BY_CODIGO = gql`
    query GetPacienteSAPByCodigo($codPaciente: String!, $idEvaluacion: Int!) {
        pacienteSAPByCodigo(codPaciente: $codPaciente, idEvaluacion: $idEvaluacion) {
            success
            valorEsperado {
                idPaciente
                cod_Paciente
                nombre
                tipoDoc
                numeroDoc
                domicilio
                provincia
                piso
                departamento
                cP
                localidad
                cod_Provincia
                pais
                observacionExtra
            }
            error
        }
    }
`;

export const adaptPacienteSAP = (paciente) => {
  return {
    // idPaciente: paciente.idPaciente,
    codigoSAP: paciente.cod_Paciente,
    nombre: paciente.nombre,
    tipoDocumento: paciente.tipoDoc,
    numeroDocumento: paciente.numeroDoc,
    direccion: paciente.domicilio,
    provincia: paciente.provincia,
    piso: paciente.piso,
    departamento: paciente.departamento,
    codigoPostal: paciente.cP,
    localidad: paciente.localidad,
    cod_Provincia: paciente.cod_Provincia,
    pais: paciente.pais,
    observacionExtra: paciente.observacionExtra
  };
};